module.exports = __webpack_public_path__ + "static/media/109.47a495cc.jpg";